import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Talent } from "@tvg/ts-types/Talent";

export type State = {
  selectedTalent: Talent | null;
};

export const initialState: State = {
  selectedTalent: null
};

const talentSlice = createSlice({
  name: "talent",
  initialState,
  reducers: {
    setSelectedTalent(state, action: PayloadAction<Talent | null>) {
      state.selectedTalent = action.payload;
    }
  }
});

export const { setSelectedTalent } = talentSlice.actions;

export default talentSlice.reducer;
